import styled, { css } from 'styled-components';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter } from '../../global/commonStyle';

interface Props {
  isMargin?: boolean;
  isImage?: boolean;
  type?: string;
}

const Main = styled.div<Props>`
  display: flex;

  .img {
    max-width: 300px;
    max-height: 300px;
    width: auto;
    height: auto;
  }
  ${mobile_xl(css`
    .img {
      width: auto;
      max-width: 100%;
    }
  `)}
  ${(props) =>
    props.isMargin &&
    css`
      margin-top: var(--space-6);
    `}
  ${(props) =>
    props.isImage &&
    css`
      margin-top: var(--space-12);
      :first-child {
        margin-top: var(--space-12) !important;
      }
    `}
`;

const CustomPreviewIcon = styled.div`
  ${AlignCenter}
  gap: var(--space-24);
`;

const LeftPreview = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const CenterLine = styled.div`
  height: 32px;
  border-left: 1px solid var(--border-secondary);
`;

export { CenterLine, CustomPreviewIcon, LeftPreview, Main };
